import { appConfig } from '@common/config';
import { Category, type ICategoryProp } from '@components/Category';
import { Checkbox, type ICheckbox } from '@components/Checkbox';
import { OnOff, type IOnOffProp } from '@components/OnOff';
import { RadioSelect, type IRadioSelect } from '@components/RadioSelect';
import { RangeSlider, type IRangeSliderProp } from '@components/RangeSlider';
import { type IPriceParams } from '@interface/IItemPrice';
import { useTranslation } from 'react-i18next';
import { FilterWrapTempl } from './FilterWrapTempl';

export const FilterWrapLm = ({ props }: { props: IPriceParams }) => {
    const { t } = useTranslation();

    const classCheckProp: ICheckbox = {
        title: t('common.class'),
        resetObj: { page: '' },
        watch: 'class',
        cls: 'class',
        path: `/${appConfig.service}/v2.0/game/character/class`,
        ga360str: '시세_조건검색_클래스_클릭',
        activeChecked: props.paramClass,
    };

    const gradeCheckProp: ICheckbox = {
        title: t('common.grade'),
        resetObj: { page: '' },
        watch: 'grade',
        cls: 'grade',
        path: `/${appConfig.service}/v2.0/game/item/grade`,
        ga360str: '시세_조건검색_등급_클릭',
        activeChecked: props.paramGrade,
    };

    const rangeSliderProp: IRangeSliderProp = {
        watch1: 'enchantfrom',
        watch2: 'enchantto',
        min: 0,
        max: 11,
        step: 1,
        ga360str: '시세_조건검색_강화단계_클릭',
        activeEnchantfrom: props.paramEnchantfrom,
        activeEnchantto: props.paramEnchantto,
    };

    const blessProp: IRadioSelect = {
        title: t('noti.blessed'),
        resetObj: { page: '' },
        watch: 'bless',
        cls: 'bless',
        path: `/${appConfig.service}/v2.0/game/item/bless`,
        ga360str: '시세_조건검색_축복_클릭',
        activeBless: props.paramBless,
    };

    const onoffProp: IOnOffProp = {
        watch: 'sale',
        resetObj: { page: '' },
        title: t('price.checksale'),
        description: t('common.showcurrentitems'),
        ga360str: '시세_조건검색_판매여부_클릭',
        initVal: 'true',
        activeChecked: props.paramSale,
    };

    const categoryProp: ICategoryProp = {
        title: t('common.category'),
        watchD1: 'category1',
        watchD2: 'category2',
        path: `/${appConfig.service}/v2.0/game/market/category`,
        ga360str: '시세_조건검색_카테고리_클릭',
        activeCategory1: props.paramCategory1,
        activeCategory2: props.paramCategory2,
    };

    return (
        <FilterWrapTempl refreshObj={refObj}>
            <Checkbox props={classCheckProp} />
            <Checkbox props={gradeCheckProp} />
            <RangeSlider props={rangeSliderProp} />
            <RadioSelect props={blessProp} />
            <OnOff props={onoffProp} />
            <Category props={categoryProp} />
        </FilterWrapTempl>
    );
};

const refObj = {
    class: '',
    grade: '',
    sale: 'true',
    category1: '',
    category2: '',
    enchantfrom: '',
    enchantto: '',
    bless: '',
    page: '',
};
